import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"20px","display":"flex","align-items":"center","justify-content":"space-between","background":"#f9f9f9","padding":"15px","border-radius":"8px"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Borrar todas ")
const _hoisted_4 = {
  key: 1,
  style: {"display":"flex","align-items":"center","gap":"12px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold","font-size":"14px"} }, "Configurar nuevas matrices:", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Generar ")
const _hoisted_7 = { style: {"display":"flex","align-items":"center","gap":"12px"} }
const _hoisted_8 = ["src"]
const _hoisted_9 = { style: {"display":"flex","justify-content":"flex-end","gap":"10px"} }

import { ref, watch, computed, onMounted } from "vue";
import { Upload, Delete } from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";
import cloneDeep from "lodash/cloneDeep";
import { createTmoas, deleteTmoas, updateTmoa, uploadTmoaImage } from "@/service/tmoa.service";
import { useRoute } from "vue-router";
import { getSamplingPointById } from "@/service/samplingpoint.service";
import { Station } from "@/types";
import { getImageTmoa } from "@/service/image.service";


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: Boolean,
  tmoas: { type: Array as any, default: () => [] },
  canEdit: { type: Boolean, default: true },
  samplingPointId: [String, Number],
  colorOptions: {
    type: Array as any,
    default: () => [
      // Colores por defecto
      "#67B7DC",
      "#6794DC",
      "#6771DC",
      "#8067DC",
      "#A367DC",
      "#C767DC",
      "#DC67CE",
      "#D667DC",
      "#E167DC",
      "#F167DC",

      // Amarillos
      "#F2E5A0",
      "#E8D98B",
      "#D9C87A",

      // Verdes
      "#A6B88F",
      "#8FA67A",
      "#768F63",
      "#6B7F58",

      // Marrones
      "#C2A27A",
      "#A88963",
      "#8B6F4E",

      // Azules
      "#A7B6C9",
      "#8FA1B5",
      "#768A9A",

      // Turquesa
      "#88A8A0",
      "#72948C",

      // Grises
      "#C7C7C2",
      "#B3B3AE",
      "#9A9A95",

      // Ocres
      "#B8A97A",
      "#9E8E6A",

      // Anomalía
      "#F37878",
    ],
  },
},
  emits: ["update:modelValue", "refresh"],
  setup(__props, { emit }) {

const props = __props





const localTmoas = ref<any[]>([]);
const numToCreate = ref(1);
const showPreview = ref(false);
const previewContent = ref("");
const previewName = ref("");
const saving = ref(false);

// PROPIEDAD COMPUTADA: Filtra las TMOAs que pertenecen al punto actual
const filteredTmoas = computed(() => {
  return localTmoas.value.filter((t) => t.samplingPoint?.id === props.samplingPointId);
});

watch(
  () => props.modelValue,
  (isOpen) => {
    if (isOpen) {
      localTmoas.value = cloneDeep(props.tmoas);
    }
  },
  { immediate: true }
);

const station = ref<string>("");
const itemsToDelete = ref<number[]>([]);
const arrayNums = [
  "I",
  "II",
  "III",
  "IV",
  "V",
  "VI",
  "VII",
  "VIII",
  "IX",
  "X",
  "XI",
  "XII",
  "XIII",
  "XIV",
  "XV",
  "XVI",
  "XVII",
  "XVIII",
  "XIX",
];

onMounted(async () => {
  const route = useRoute();
  const samplingPointId = route.query.samplingPoint;

  if (samplingPointId) {
    const sp = await getSamplingPointById(Number(samplingPointId));
    station.value = (sp.station as Station).station || "";
  }
});
// Genera N nuevas tipologías
const generateNewTmoas = () => {
  const newItems = [];
  for (let i = 1; i <= numToCreate.value; i++) {
    const name = i < numToCreate.value ? `Tipología ` + arrayNums[i - 1] : "Anomalía";
    const color =
      i < numToCreate.value ? props.colorOptions[(i - 1) % props.colorOptions.length] : "#F37878";

    newItems.push({
      name: name,
      value: i,
      color: color,
      samplingPoint: { id: props.samplingPointId },
      file: null,
      fileName: "",
    });
  }
  localTmoas.value = [...localTmoas.value, ...newItems];
};

const confirmDeleteAll = () => {
  ElMessageBox.confirm("¿Eliminar todas las matrices de este punto?", "Atención", {
    confirmButtonText: "Borrar",
    cancelButtonText: "Cancelar",
    type: "warning",
  }).then(() => {
    const ids = filteredTmoas.value.filter((t) => t.id).map((t) => t.id);

    itemsToDelete.value = [...itemsToDelete.value, ...ids];

    localTmoas.value = localTmoas.value.filter(
      (t) => t.samplingPoint?.id !== props.samplingPointId
    );
  });
};

const handleImageUpload = (file: any, indexInFiltered: number) => {
  const target = filteredTmoas.value[indexInFiltered];
  if (target) {
    target.file = file.raw;
    target.fileName = file.name;
  }
};

const removeImage = (indexInFiltered: number) => {
  const target = filteredTmoas.value[indexInFiltered];
  if (target) {
    target.file = null;
    target.fileName = "";
  }
};

const openPreview = (file: any, name: string) => {
  getImageTmoa(file).then((res) => {
    previewContent.value = res;
  });
  previewName.value = name;
  showPreview.value = true;
};

const handleSave = async () => {
  try {
    saving.value = true;

    if (itemsToDelete.value.length > 0) {
      await deleteTmoas(itemsToDelete.value);
      itemsToDelete.value = [];
    }

    for (const tmoa of filteredTmoas.value) {
      if (tmoa.file instanceof File) {
        const res = await uploadTmoaImage(station.value, tmoa.file);
        tmoa.file = res.data.url;
      }
    }

    const toUpdate = filteredTmoas.value.filter((t) => t.id);
    const toCreate = filteredTmoas.value
      .filter((t) => !t.id)
      .map((t) => ({
        name: t.name,
        value: t.value,
        file: t.file,
        color: t.color,
        samplingPointId: props.samplingPointId,
      }));

    const updatePromises = toUpdate.map((t) => updateTmoa(t.id, t.name, t.value, t.file, t.color));

    const promises: Promise<any>[] = [...updatePromises];
    if (toCreate.length > 0) {
      promises.push(createTmoas(toCreate));
    }

    await Promise.all(promises);

    ElMessage.success("Guardado correctamente");
    emit("refresh");
    emit("update:modelValue", false);
  } catch (err) {
    console.error("Error en el guardado:", err);
    ElMessage.error("Error");
  } finally {
    saving.value = false;
  }
};

watch(
  () => props.tmoas,
  (newVal) => {
    if (props.modelValue) {
      localTmoas.value = cloneDeep(newVal);
    }
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.modelValue,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    width: "50%",
    title: _ctx.$t('info_tmoa.title_info'),
    "append-to-body": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSave,
          loading: saving.value,
          disabled: !props.canEdit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(filteredTmoas).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_el_button, {
                type: "danger",
                plain: "",
                onClick: confirmDeleteAll,
                disabled: !props.canEdit
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, { style: {"margin-right":"4px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Delete))
                    ]),
                    _: 1
                  }),
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["disabled"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_el_input_number, {
                modelValue: numToCreate.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((numToCreate).value = $event)),
                min: 1,
                max: 20,
                size: "default"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: generateNewTmoas
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]))
      ]),
      _createVNode(_component_el_form, { "label-position": "top" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredTmoas), (tmoa, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              style: {"margin-bottom":"20px","padding":"20px","border":"1px solid #ebeef5","border-radius":"12px","box-shadow":"0 2px 12px 0 rgba(0, 0, 0, 0.05)"}
            }, [
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('info_tmoa.name')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: tmoa.name,
                            "onUpdate:modelValue": ($event: any) => ((tmoa.name) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["label"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('info_tmoa.value')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "number",
                            modelValue: tmoa.value,
                            "onUpdate:modelValue": ($event: any) => ((tmoa.value) = $event),
                            modelModifiers: { number: true }
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["label"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "Imágen de referencia" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_el_upload, {
                              "on-change": (file) => handleImageUpload(file, index),
                              "show-file-list": false,
                              accept: "image/*",
                              "auto-upload": false
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  size: "small",
                                  circle: "",
                                  disabled: !props.canEdit
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Upload))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 2
                            }, 1032, ["on-change"]),
                            (tmoa.file)
                              ? (_openBlock(), _createBlock(_component_el_link, {
                                  key: 0,
                                  type: "primary",
                                  onClick: ($event: any) => (openPreview(tmoa.file, tmoa.name))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(tmoa.fileName || "Ver imagen"), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true),
                            (tmoa.file)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  type: "danger",
                                  icon: "Delete",
                                  size: "small",
                                  link: "",
                                  onClick: ($event: any) => (removeImage(index)),
                                  disabled: !props.canEdit
                                }, null, 8, ["onClick", "disabled"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('info_tmoa.color')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_color_picker, {
                            modelValue: tmoa.color,
                            "onUpdate:modelValue": ($event: any) => ((tmoa.color) = $event),
                            predefine: __props.colorOptions,
                            "color-format": "hex"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "predefine"])
                        ]),
                        _: 2
                      }, 1032, ["label"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        modelValue: showPreview.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showPreview).value = $event)),
        title: previewName.value,
        "append-to-body": "",
        width: "50%"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: previewContent.value,
            style: {"width":"100%"}
          }, null, 8, _hoisted_8)
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})